import { LegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

export const getContractType = (
  contractVersion: ContractVersion,
  legalEntityData: LegalEntityContractData
): string | null => {
  let contractTypes = null
  let contractTypeId: number | null = null

  if (contractVersion.isSpanish) {
    contractTypes = legalEntityData.spanishContractData.contractTypes
    contractTypeId = contractVersion.attributes.es_contract_type_id
  } else if (contractVersion.isFrench) {
    contractTypes = legalEntityData.frenchContractData.contractTypes
    contractTypeId = contractVersion.attributes.fr_contract_type_id
  } else if (contractVersion.isGerman) {
    contractTypes = legalEntityData.germanContractData.contractTypes
    contractTypeId = contractVersion.attributes.de_contract_type_id
  } else if (contractVersion.isPortuguese) {
    contractTypes = legalEntityData.portugueseContractData.contractTypes
    contractTypeId = contractVersion.attributes.pt_contract_type_id
  }

  if (!contractTypes) return null

  const contractType = contractTypes.find(({ id }) => id === contractTypeId)
  return contractType?.name || ''
}
